"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Table = void 0;
var react_1 = __importDefault(require("react"));
var antd_1 = require("antd");
var styled_components_1 = __importDefault(require("styled-components"));
// eslint-disable-next-line import/no-cycle
var _1 = require(".");
var array_1 = require("../../utils/array");
var CustomTable = styled_components_1.default(antd_1.Table)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  .ant-table-thead .ant-table-cell {\n    background-color: transparent;\n  }\n\n  .ant-table-cell {\n    border: none;\n    padding-bottom: 4px !important;\n    padding-top: 4px !important;\n  }\n\n  thead > tr > th {\n    color: #8c8c8c;\n    font-weight: 400;\n  }\n\n  .ant-table-thead\n    > tr\n    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n    display: none;\n  }\n\n  & .selectable-search-table-item-disabled {\n    opacity: 0.8;\n    background-color: #f1f1f1 !important;\n    & .ant-table-cell-row-hover {\n      background-color: #f1f1f1 !important;\n    }\n    pointer-events: none;\n    cursor: not-allowed;\n  }\n"], ["\n  .ant-table-thead .ant-table-cell {\n    background-color: transparent;\n  }\n\n  .ant-table-cell {\n    border: none;\n    padding-bottom: 4px !important;\n    padding-top: 4px !important;\n  }\n\n  thead > tr > th {\n    color: #8c8c8c;\n    font-weight: 400;\n  }\n\n  .ant-table-thead\n    > tr\n    > th:not(:last-child):not(.ant-table-selection-column):not(.ant-table-row-expand-icon-cell):not([colspan])::before {\n    display: none;\n  }\n\n  & .selectable-search-table-item-disabled {\n    opacity: 0.8;\n    background-color: #f1f1f1 !important;\n    & .ant-table-cell-row-hover {\n      background-color: #f1f1f1 !important;\n    }\n    pointer-events: none;\n    cursor: not-allowed;\n  }\n"])));
var Styledtr = styled_components_1.default.tr(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n\n  ", "\n\n  & .ant-table-cell-row-hover {\n    background: whitesmoke !important;\n  }\n\n  ", "\n\n  ", "\n\n  &.ant-table-placeholder {\n    background: transparent !important;\n  }\n"], ["\n  cursor: pointer;\n\n  ",
    "\n\n  & .ant-table-cell-row-hover {\n    background: whitesmoke !important;\n  }\n\n  ",
    "\n\n  ",
    "\n\n  &.ant-table-placeholder {\n    background: transparent !important;\n  }\n"])), function (_a) {
    var $background = _a.$background;
    return "\n    background: " + $background + ";\n  ";
}, function (_a) {
    var $disabled = _a.$disabled, $background = _a.$background;
    return $disabled
        ? "\n      & .ant-table-cell-row-hover {\n        background: " + $background + " !important;\n      }\n  "
        : "";
}, function (_a) {
    var $selected = _a.$selected, $background = _a.$background;
    return $selected
        ? "\n      background: " + $background + " !important;\n      & .ant-table-cell-row-hover {\n        background: " + $background + " !important;\n      }\n  "
        : "";
});
var CustomRow = function (_a) {
    var restProps = __rest(_a, []);
    var _b = _1.useOptContext(), currentValue = _b.value, listDisabled = _b.disabled, onChange = _b.onChange;
    var key = restProps["data-row-key"];
    var selected = currentValue === null || currentValue === void 0 ? void 0 : currentValue.includes(key);
    var onRowClick = function () {
        onChange === null || onChange === void 0 ? void 0 : onChange([key]);
    };
    return (react_1.default.createElement(Styledtr, __assign({ "$disabled": listDisabled, "$background": array_1.array(selected && _1.variantConfig.default.optionBackground, "transparent")[0], "$selected": selected }, restProps, { onClick: onRowClick })));
};
var Table = function (_a) {
    var tableProps = __rest(_a, []);
    return (react_1.default.createElement(CustomTable, __assign({}, tableProps, { size: "small", pagination: false, components: {
            body: {
                row: CustomRow,
            },
        }, onRow: function (record) {
            if (record.disabled) {
                return {
                    className: "selectable-search-table-item-disabled",
                };
            }
            return {};
        } })));
};
exports.Table = Table;
var templateObject_1, templateObject_2;
